/* eslint-disable no-undef */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
import React, {
    useEffect, useMemo, useRef, useState,
} from 'react';
import {
    useFragment, useReactiveVar,
} from '@apollo/client';
import queryString from 'query-string';
import { selectedPeriodVar, subscriptionTypeVar } from 'app/apollo/reaction';
import { isSubscription } from 'app/const/subscription';

import { GiftPackRow } from 'app/views/Checkout/additionalOrderOptions/components/GiftPackRow';
import { useDishDetails } from 'app/components/MobileDishDetails/hooks/useDishDetails';
import { analyticService } from 'global/services';
import { AdditionalDish } from 'app/views/Checkout/additionalOrderOptions/components/AdditionalDishRow';
import { TableSetting } from 'app/views/Checkout/additionalOrderOptions';
import { useBasketQueryLocate } from 'app/hooks/useBasketQueryLocate';
import { useParticipantIdABTest } from 'app/views/Menu/Menu/hooks/useParticipantIdABTest';
import { CHANGE_DISH, CHANGE_DISH_TEST, CHANGE_DISH_CONTROL } from 'app/containers/contexts/abTest.context';
import {
    INITIAL_DELIVERY_DATE_AND_TIME_FORM_DATA,
} from '../../Profile/__NextProfile/ProfileDeliveriesPage/components/DeliveryEditForms/DeliveryDateAndTimeForm/graphql/deliveryEditRowDateAndTime.graphql';
import AddMoreDishesButton from './components/AddMoreDishes/AddMoreDishes';
import { NewDishCard } from './components/BasketDishCard/BasketDishCard';
import FurtherPeriodDishes, { formatFurtherPeriodDate } from './components/FurtherPeriodDishes/FurtherPeriodDishes';
import { GiftDishCard } from '../CommonComponents/GiftDishCard';

import './index.scss';
import { useRouterState } from 'app/hooks/useRouterState';
import { extraPeriodNYEnd, extraPeriodNYStart } from 'global/const/ny';
import { isDateInRange } from 'app/containers/contexts/filters.context/filters.context';
import { AdditionalDishWithTableSetting } from 'app/views/Checkout/additionalOrderOptions/components/AdditionalDishWithTableSetting';

import firtherDishesCss from './components/FurtherPeriodDishes/furtherPeriodDishes.module.scss';

const tableSettingPeriods = [
    '2026-02-09',
    '2026-02-30',
    '2026-03-06',
];


const BasketWithCustomization = (props) => {
    const {
        handleAddMoreButtonClick,
        handleChangePortion,
        onClickMobilePortions,
        handleRemoveDish,
        mutateItemInCart,
        primetiveSection,
        sectionItems,
        isCartUpdating,
        isEditEnabled = true,
    } = props;

    const deliveryId = window.location.pathname.split('/').find((e) => Boolean(e) && !Number.isNaN(Number(e)));
    const { data: currentDeliveryData } = useFragment({
        fragment: INITIAL_DELIVERY_DATE_AND_TIME_FORM_DATA,
        from: { __ref: `delivery:${deliveryId}` },
    });

    const rootRef = useRef(null);
    const [{ location }] = useRouterState();
    const subscriptionType = useReactiveVar(subscriptionTypeVar);
    const period = useReactiveVar(selectedPeriodVar);

    const [hasFurtherPeriodDishes, setHasFurtherPeriodDishes] = useState(false);

    const { openDishDetails } = useDishDetails();

    /* SELECTORS */
    const isEditBasketBlock = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hideParams = urlParams.get('hide') || '';
        const param = hideParams || '';
        return param?.includes('edit_basket') || !isEditEnabled;
    }, [isEditEnabled]);

    const isInExtraPeriod = useMemo(
        () => currentDeliveryData?.date === extraPeriodNYStart || currentDeliveryData?.date === extraPeriodNYEnd,
        [currentDeliveryData],
    );

    const giftBannerId = useMemo(
        () => {
            const params = queryString.parse(window.location.search);
            return params?.gbid || null;
        },
        [],
    );

    const basketDishObserver = useMemo(
        () => new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    const intersectingDish = sectionItems
                        .filter((dish) => dish.dish_id === e.target.dataset.id);

                    analyticService.push({
                        eventName: 'Product_Impression',
                        dish: [intersectingDish[0].dish],
                        subscriptionType,
                        source_name: 'basket',
                    });
                }
            });
        },
        { rootMargin: '0px', threshold: 0.45 }),
        [sectionItems, subscriptionType],
    );

    // const cartDishesIds = useMemo(
    //     () => sectionItems.map((item) => item.dish_id),
    //     [sectionItems],
    // );

    const isRomanticEditDisabled = sessionStorage.getItem('is_romantic_edit_disabled') || isEditBasketBlock;

    const hasDishesInDeliveryBasket = useMemo(
        () => currentDeliveryData?.dishes
            ?.map((d) => d?.id)
            .some((dish) => dish.includes('4847') || dish.includes('5267')),
        [currentDeliveryData],
    );


    const isNeedToShowTableSetting = useMemo(
        () => tableSettingPeriods.some((p) => isDateInRange(p, period, 1))
            && !isRomanticEditDisabled && !hasDishesInDeliveryBasket,
        [period, isRomanticEditDisabled, hasDishesInDeliveryBasket],
    );

    useEffect(
        () => () => basketDishObserver.disconnect(),
        [primetiveSection, basketDishObserver],
    );

    return (
        <>
            <div styleName="new-dish-list" ref={rootRef}>
                {giftBannerId && <GiftDishCard id={giftBannerId} />}
                {[
                    '2026-10-12',
                    '2026-10-19',
                    '2026-10-26',
                ].some((p) => isDateInRange(p, period, 1)) && <GiftDishCard id="tefal" />}
                {hasFurtherPeriodDishes && (
                    <div className={`${firtherDishesCss.furtherPeriodDishesHeaderContainer} ${firtherDishesCss.noMargin}`}>
                        <div className={`body-l-semibold ${firtherDishesCss.furtherPeriodDishesHeading}`}>
                            {isSubscription(subscriptionType)
                                ? 'Заказ по подписке'
                                : 'Основной заказ'}
                        </div>
                        <div className={`body-s-medium ${firtherDishesCss.furtherPeriodDishesTitle}`}>
                            {`доставка с ${period ? formatFurtherPeriodDate(period) : ''}`}
                        </div>
                    </div>
                )}
                {primetiveSection.map((cacheRef) => {
                    if (cacheRef === 'cartItem:4847') {
                        return null;
                    }

                    if (cacheRef === 'cartItem:5267') {
                        return null;
                    }

                    if (cacheRef === 'cartItem:5375') {
                        return null;
                    }

                    return (
                        <NewDishCard
                            key={cacheRef}
                            cacheRef={cacheRef}
                            handleChangePortion={handleChangePortion}
                            handleRemoveDish={handleRemoveDish}
                            onClickMobilePortions={onClickMobilePortions}
                            openDishDetails={openDishDetails}
                            mutateItemInCart={mutateItemInCart}
                            isCartUpdating={isCartUpdating}
                            isEditBasketBlock={isEditBasketBlock}
                            basketDishObserver={basketDishObserver}
                        />
                    );
                })}
            </div>
            <div styleName="tableSettingTogglesWrapper">
                <TableSetting
                    realm="basket"
                    show={isNeedToShowTableSetting}
                />
            </div>
            {!isEditBasketBlock && !isNeedToShowTableSetting && (
                <div styleName="new-dish-list">
                    <AdditionalDish />
                </div>
            )}
            <FurtherPeriodDishes
                onClickMobilePortions={onClickMobilePortions}
                openDishDetails={openDishDetails}
                onHasContentChange={setHasFurtherPeriodDishes}
            />
            {/* {!isEditBasketBlock && (
                <div styleName="tableSettingTogglesWrapper">
                    <AdditionalDishWithTableSetting />
                </div>
            )} */}
            {/* {isNeedToShowTableSetting && (
                <div styleName="tableSettingTogglesWrapper">
                    <GiftPackRow
                        realm="basket"
                        primetiveSection={primetiveSection}
                    />
                </div>
            )} */}
            {isEditBasketBlock || isInExtraPeriod ? (
                <>
                    <div styleName="newUpsellDividerGrey" />
                    <div styleName="newUpsellDividerWhite" />
                </>
            ) : (
                <AddMoreDishesButton
                    handleAddMoreButtonClick={handleAddMoreButtonClick}
                />
            )}
        </>
    );
};

export default React.memo(BasketWithCustomization);
